import React, { useEffect, useLayoutEffect, useState } from "react";
import { APP_SERVICES_URL } from "../../Constant/constant";
import userSession from "../../Constant/auth";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import loading from "../../Assets/loading.gif";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import { Modal } from "react-bootstrap";
import "../../CSS/showImageModal.css";
import { IoIosRefresh } from "react-icons/io";
import moment from "moment";
import axios from "axios";

const ShowImageModal = ({
  selectedOptions,
  setCameraData,
  cameraData,
  show,
  onHide,
}) => {
  const { CustID, authHeader, site } = userSession;
  const [showLiveImageUrl, setShowLiveImageUrl] = useState("");
  const [updateOcrValue, setUpdateOcrValue] = useState();
  const [showDetectedImageUrl, setShowDetectedImageUrl] = useState("");
  const [liveImageLoading, setLiveImageLoading] = useState(true);
  const [detectedImageLoading, setDetectedImageLoading] = useState(true);
  const [response, setResponse] = useState(false);

  function getLocalTimezoneISO() {
    // Get the current date and time in the local time zone
    const localTime = moment();

    // Format the date in ISO 8601 format with the local time zone offset
    const localTimeWithOffset = localTime.format("YYYY-MM-DDTHH:mm:ss.SSS");

    return localTimeWithOffset;
  }

  // Function to handle OCR update success notification
  const handleSuccessNotification = () => {
    // NotificationManager.success("OCR updated successfully", "Success", 3000);
  };

  // Function to handle OCR update failure notification
  const handleFailureNotification = () => {
    NotificationManager.error(
      <div className="showNormalFont">
        OCR update failed. Please try again later
      </div>,
      <div className="showNormalFont">Error</div>,
      3000
    );
  };

  useEffect(() => {
    setUpdateOcrValue(selectedOptions.ocr);
  }, [selectedOptions]);

  const fetchImageUrl = async (imageSrcURL) => {
    try {
      // Parse the URL using JSON.parse to handle escaped characters and quotes
      const parsedUrl = JSON.parse(imageSrcURL);
      const response = await fetch(parsedUrl, {
        method: "GET",
      });

      if (!response.ok) {
        setDetectedImageLoading(false);
        NotificationManager.error(
          <div className="showNormalFont">
            Failed to fetch detected image. Please try again later
          </div>,
          <div className="showNormalFont">Error</div>,
          3000
        );
        throw new Error("Image network response was not ok");
      }

      const blob = await response.blob();
      const imageUrlResponse = URL.createObjectURL(blob);
      setShowDetectedImageUrl(imageUrlResponse);
      setDetectedImageLoading(false);
    } catch (error) {
      console.error("Image Fetch error:", error);
      setDetectedImageLoading(false);
      return null;
    }
  };

  // Function to fetch the showImage
  const fetchShowDetectedImage = async () => {
    try {
      const response = await fetch(
        `${APP_SERVICES_URL}/sn-events-service/${CustID}/eventImage?eventID=${selectedOptions.eventID}&type=source&siteName=${site.name}`,
        {
          headers: {
            Authorization: authHeader,
          },
        }
      );

      if (!response.ok) {
        setDetectedImageLoading(false);
        NotificationManager.error(
          <div className="showNormalFont">
            Failed to fetch detected image. Please try again later
          </div>,
          <div className="showNormalFont">Error</div>,
          3000
        );
        throw new Error("Failed to fetch the showImage.");
      }
      const imageSrcURL = await response.text(); // Assuming the response is a plain text URL
      fetchImageUrl(imageSrcURL); // Pass the URL directly to the function
    } catch (error) {
      // Handle error condition
      setDetectedImageLoading(false);
    }
  };

  const fetchShowLiveImage = async (pumpName) => {
    try {
      const response = await fetch(
        `${APP_SERVICES_URL}/sn-events-service/${CustID}/liveImage?siteName=${site.name}&pumpName=${pumpName}`,
        {
          headers: {
            Authorization: authHeader,
          },
        }
      );

      if (!response.ok) {
        NotificationManager.error(
          <div className="showNormalFont">
            Failed to fetch live image. Please try again later
          </div>,
          <div className="showNormalFont">Error</div>,
          3000
        );
        setLiveImageLoading(false);
        return;
      }

      // Convert the byte array to a Blob object
      const imageBlob = await response.blob();

      // Create a URL for the Blob object to display the image
      const imageUrl = URL.createObjectURL(imageBlob);

      setShowLiveImageUrl(imageUrl);
      setLiveImageLoading(false);
    } catch (error) {
      // Handle error condition
      setLiveImageLoading(false);
    }
  };

  // Call the fetchShowLiveImage function when the component mounts or the eventID changes
  useLayoutEffect(() => {
    if (selectedOptions.pumpName !== undefined && show === true) {
      fetchShowLiveImage(selectedOptions.pumpName);
    }
    if (selectedOptions.ocr && show === true) {
      // console.log("fetchShowDetectedImage will run");
      fetchShowDetectedImage();
    }
    // eslint-disable-next-line
  }, [show]);

  const handleRefereshLiveImage = () => {
    if (selectedOptions.pumpName !== undefined && show === true) {
      setLiveImageLoading(true);
      setShowLiveImageUrl("");
      fetchShowLiveImage(selectedOptions.pumpName);
    }
  };

  //Function to update OCR
  const updateOcr = async (id, ocr) => {
    const url = `${APP_SERVICES_URL}/sn-events-service/${CustID}/ocrCorrection`;
    // console.log("1. Starting OCR update with:", { id, ocr, url });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: authHeader,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          ocr: ocr,
        }),
      });
      // console.log("2. Received response:", {
      //   status: response.status,
      //   statusText: response.statusText,
      // });

      // First check if there's any content
      const contentType = response.headers.get("content-type");
      // console.log("3. Content-Type:", contentType);
      let updatedOffence = undefined;

      if (response.ok) {
        // Try to get the raw response text first
        const responseText = await response.text();
        // console.log("4. Raw response text:", responseText);

        if (responseText) {
          if (contentType && contentType.includes("application/json")) {
            try {
              // Parse the text as JSON if it's JSON content
              updatedOffence = JSON.parse(responseText);
              // console.log("5a. Parsed JSON response:", updatedOffence);
            } catch (parseError) {
              // console.warn("5b. Could not parse JSON response:", parseError);
            }
          } else {
            // If it's not JSON but we have text, use the text directly
            updatedOffence = responseText;
            // console.log(
            //   "5c. Using raw text as updatedOffence:",
            //   updatedOffence
            // );
          }
        } else {
          // console.log(
          //   "5d. No response content, setting updatedOffence as undefined"
          // );
        }

        // Log the current state before update
        // console.log("6. Current camera data:", {
        //   totalCameras: cameraData.length,
        //   selectedPump: selectedOptions.pumpName,
        //   matchingCameras: cameraData.filter(
        //     (c) => c.pumpName === selectedOptions.pumpName
        //   ).length,
        // });

        // Update the camera data
        const updatedCameraData = cameraData.map((camera) => {
          if (camera.pumpName === selectedOptions.pumpName) {
            const updatedCamera = {
              ...camera,
              ocr: ocr,
              previousOffenceType: updatedOffence,
            };
            // console.log("7. Updating camera:", {
            //   pumpName: camera.pumpName,
            //   oldOcr: camera.ocr,
            //   newOcr: ocr,
            //   oldOffenceType: camera.previousOffenceType,
            //   newOffenceType: updatedOffence,
            // });
            return updatedCamera;
          }
          return camera;
        });

        // console.log("8. Updated camera data summary:", {
        //   totalCameras: updatedCameraData.length,
        //   updatedCameras: updatedCameraData.filter(
        //     (c) => c.pumpName === selectedOptions.pumpName
        //   ).length,
        // });

        setCameraData(updatedCameraData);
        onHide();
        handleSuccessNotification();
        // console.log("9. Update completed successfully");
      } else {
        const errorText = await response.text();
        // console.error("Error Response:", {
        //   status: response.status,
        //   statusText: response.statusText,
        //   body: errorText,
        // });
        handleFailureNotification();
      }
    } catch (error) {
      // console.error("Network or other error:", {
      //   name: error.name,
      //   message: error.message,
      //   stack: error.stack,
      // });
      handleFailureNotification();
    }
  };

  // Function to create a new incident if eventID is invalid or missing
  const createNewIncident = async (updateOcrValue) => {
    // Check if the given value after trim is blank, null, or undefined
    if (!updateOcrValue || updateOcrValue.trim() === "") {
      NotificationManager.error(
        <div className="showNormalFont">
          Please enter a valid license number
        </div>,
        <div className="showNormalFont">Error</div>,
        3000
      );
      return; // Exit the function early if value is blank, null, or undefined
    }

    const formattedOcrValue = updateOcrValue.replace(/\s/g, "").toUpperCase();
    const apiUrl = `${APP_SERVICES_URL}/sn-events-service/${CustID}/event?getAlertInfo=true`;

    // Generate current timestamp
    const localTimezoneISO = getLocalTimezoneISO();
    const requestBody = {
      rule: "Manual Input",
      ocr: formattedOcrValue,
      pumpName: selectedOptions.pumpName,
      siteName: site.name,
      created: localTimezoneISO,
    };

    try {
      setResponse(false);
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          Authorization: authHeader,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        const { left: eventId, right: offenceType } = JSON.parse(response.data);

        // Update the `ocr` field for all elements where `pumpName` matches
        const updatedCameraData = cameraData.map((camera) => {
          if (camera.pumpName === selectedOptions.pumpName) {
            return {
              ...camera,
              eventID: eventId,
              ocr: formattedOcrValue,
              previousOffenceType: offenceType || undefined,
            };
          } else {
            return camera;
          }
        });

        setCameraData(updatedCameraData);
        setResponse(true);
        setUpdateOcrValue("");
        onHide();
      } else {
        setResponse(false);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  // Function to handle the "Update Plate" button click
  const handleUpdatePlateClick = () => {
    const eventData = {
      eventID: selectedOptions.eventID,
      ocr: updateOcrValue,
    };

    // If eventID is missing, call createNewIncident
    if (!eventData.eventID || eventData.eventID.trim() === "") {
      // console.log("Calling createNewIncident function");
      createNewIncident(updateOcrValue); // Call createNewIncident when eventID is not present
    }
    // If both eventID and ocr are present, call updateOcr
    else if (eventData.eventID && eventData.ocr) {
      // console.log("Calling updateOcr function");
      updateOcr(eventData.eventID, eventData.ocr); // Call updateOcr if both eventID and ocr are present
    }
    // If ocr is missing but eventID exists, log an error or handle accordingly
    else {
      // console.log("Invalid eventData or ocr value");
    }
  };

  useEffect(() => {
    if (show) {
      setShowLiveImageUrl("");
      setShowDetectedImageUrl("");
      setDetectedImageLoading(true);
      setLiveImageLoading(true);
    }
  }, [show]);

  const renderZoomableImage = (imageSrc, altText) => (
    <div className="zoomable-image-container">
      <img
        className="zoomable-image"
        style={{ border: "1px solid ccc" }}
        alt={altText}
        src={imageSrc}
      />
    </div>
  );

  return (
    <Modal show={show} onHide={onHide} fullscreen>
      <NotificationContainer />
      <div className="modal-dialog modal-dialog-centered modal-fullscreen">
        <div
          className="modal-content"
          style={{ backgroundColor: "#212529", color: "#FFFFFF" }}
        >
          <div className="modal-header">
            <h5 id="live-image-title">
              CAMERA VIEW -
              {selectedOptions && selectedOptions.pumpName !== undefined
                ? selectedOptions.pumpName.toUpperCase().replace(/(\d+)/, " $1")
                : ""}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onHide}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-6"></div>
              <div className="col-6">
                <div className="container">
                  <div className="input-group input-group-lg col-12">
                    <input
                      style={{
                        backgroundColor: "#212529",
                        color: "#fff",
                        borderRadius: "5px 0px 0px 5px",
                        borderColor: "#495057",
                      }}
                      type="text"
                      className="form-control showModalNormalFont"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-lg"
                      value={updateOcrValue || ""}
                      placeholder="LICENCE NUMBER"
                      onChange={(e) => {
                        // Remove non-alphanumeric characters and limit to 10 characters
                        const newValue = e.target.value
                          .replace(/[^a-zA-Z0-9]/g, "")
                          .slice(0, 10);
                        setUpdateOcrValue(newValue.toUpperCase());
                      }}
                    />
                    <button
                      style={{ borderRadius: "0px 5px 5px 0px" }}
                      type="button"
                      id="showImge-btn"
                      className="btn btn-outline-primary showModalNormalFont"
                      onClick={handleUpdatePlateClick} // Call the function on button click
                    >
                      Update Plate
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {selectedOptions && selectedOptions.ocr ? (
              <div className="row text-center">
                <div className="col-6">
                  <div className="mt-3">
                    <h5 className="showModalNormalFont">
                      Live Image
                      <span className="ms-2" style={{ cursor: "pointer" }}>
                        <IoIosRefresh onClick={handleRefereshLiveImage} />
                      </span>
                    </h5>
                    <div className="row m-2 text-center">
                      <div
                        className="col-12 mt-2"
                        style={{
                          border: "1px solid rgba(255, 255, 255, 0.15)",
                          minHeight: "70vh",
                          minWidth: "100%",
                          margin: "auto",
                          padding: "1rem",
                        }}
                      >
                        {showLiveImageUrl ? (
                          renderZoomableImage(showLiveImageUrl, "Live Image")
                        ) : liveImageLoading ? (
                          <img src={loading} alt="Loading" />
                        ) : (
                          <FontAwesomeIcon
                            icon={faTriangleExclamation}
                            style={{ fontSize: "8.5rem", color: "red" }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="mt-3">
                    <h5 className="showModalNormalFont">Detected Image</h5>
                    <div className="row m-2 text-center">
                      <div
                        className="col-12 mt-2"
                        style={{
                          border: "1px solid rgba(255, 255, 255, 0.15)",
                          minHeight: "70vh",
                          minWidth: "100%",
                          margin: "auto",
                          padding: "1rem",
                        }}
                      >
                        {showDetectedImageUrl ? (
                          renderZoomableImage(
                            showDetectedImageUrl,
                            "Detected Image"
                          )
                        ) : detectedImageLoading ? (
                          <img src={loading} alt="Loading" />
                        ) : (
                          <FontAwesomeIcon
                            icon={faTriangleExclamation}
                            style={{ fontSize: "8.5rem", color: "red" }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="row mt-3 text-center">
                  <div className="col-12 mt-2">
                    <h5 className="showModalNormalFont">
                      Live Image
                      <span className="ms-2" style={{ cursor: "pointer" }}>
                        <IoIosRefresh onClick={handleRefereshLiveImage} />
                      </span>
                    </h5>
                  </div>
                </div>
                <div className="row m-2 text-center ">
                  <div
                    className="col-12 mt-2"
                    style={{
                      border: "1px solid rgba(255, 255, 255, 0.15)",
                      minHeight: "70vh",
                      minWidth: "100%",
                      margin: "auto",
                    }}
                  >
                    {showLiveImageUrl ? (
                      renderZoomableImage(showLiveImageUrl, "Live Image")
                    ) : liveImageLoading ? (
                      <img src={loading} alt="Loading" />
                    ) : (
                      <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        style={{ fontSize: "8.5rem", color: "red" }}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ShowImageModal;
